"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPageHidden = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
/**
 * 探测当前页面是否被隐藏。
 * 拉端在技术上没有更优的判断方法，所以用这种粗略的方式大致判断，如果当前页面被隐藏，那么大概率是拉端成功，当前页面被置于后台了
 */
var isPageHidden = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
    var timeout,
      browserCompatibility,
      entry,
      _entry,
      hiddenKey,
      visibilityChangeName,
      _args = arguments;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          timeout = _args.length > 0 && _args[0] !== undefined ? _args[0] : 2500;
          // 设置隐藏属性和可见改变事件的名称，属性需要加浏览器前缀
          // since some browsers only offer vendor-prefixed support var hidden, state, visibilityChange;
          browserCompatibility = {
            hidden: 'visibilitychange',
            mozHidden: 'mozvisibilitychange',
            msHidden: 'msvisibilitychange',
            webkitHidden: 'webkitvisibilitychange'
          };
          entry = Object.entries(browserCompatibility).find(function (entry) {
            return entry[0] in document;
          });
          if (entry) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return", false);
        case 5:
          _entry = (0, _slicedToArray2.default)(entry, 2), hiddenKey = _entry[0], visibilityChangeName = _entry[1];
          return _context.abrupt("return", new Promise(function (resolve) {
            document.addEventListener(visibilityChangeName, function () {
              // @ts-ignore
              if (document[hiddenKey]) {
                resolve(true);
              }
            });
            window.addEventListener('pagehide', function () {
              // @ts-ignore
              if (document[hiddenKey]) {
                resolve(true);
              }
            });
            var timer = setTimeout(function () {
              clearTimeout(timer);
              // @ts-ignore
              resolve(document[hiddenKey]);
            }, timeout);
          }));
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function isPageHidden() {
    return _ref.apply(this, arguments);
  };
}();
exports.isPageHidden = isPageHidden;